import React from 'react';

import { styled } from '@mui/system';

const Wrapper = styled('div')({
	display: 'flex',
	justifyContent: 'center',
	flexDirection: 'column',
	width: '100%',
	marginTop: '18px',
});
const Label = styled('p')({
	color: '#b9bbbe',
	textTransform: 'uppercase',
	fontWeight: '600',
	fontSize: '12px',
	letterSpacing: '0',
	margin: '0 0 8px',
});
const Input = styled('input')({
	flexGrow: 1,
	height: '44px',
	border: '1px solid #0b0c0e',
	borderRadius: '4px',
	color: '#dcddde',
	background: '#151619',
	margin: 0,
	fontSize: '16px',
	padding: '0 12px',
	outline: 'none',
	transition: 'border-color 120ms ease, background-color 120ms ease',
	boxSizing: 'border-box',
	'&::placeholder': {
		color: '#72767d',
	},
	'&:hover': {
		borderColor: '#040405',
	},
	'&:focus': {
		borderColor: '#f97316',
		background: '#151619',
	},
});

const InputWithLabel = (props) => {
	const { value, setValue, label, type, placeholder } = props;

	const handleValueChange = (event) => {
		setValue(event.target.value);
	};
	return (
		<Wrapper>
			<Label>{label}</Label>
			<Input
				value={value}
				onChange={handleValueChange}
				type={type}
				placeholder={placeholder}
			/>
		</Wrapper>
	);
};

export default InputWithLabel;
